import styled from "styled-components";

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

export default Table;
